import React from 'react';
import Logo from '../../elements/logo/Logo';
import Nav from './Nav';
import StickyHeader from './StickyHeader';
import { Link, useLocation } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import { useLanguage } from '../../context/LanguageContext';
import { useTheme } from '../../context/ThemeContext';
import { Features } from '../../assets/features/Features';
import InfoButton from '../../elements/info-button/InfoButton';


const HeaderOne = () => {
    const { language } = useLanguage();
    const { theme } = useTheme();
    const location = useLocation();
    const sticky = StickyHeader(100);
    
    // Check if we're on home page
    const isHomePage = location.pathname === process.env.PUBLIC_URL + "/" || location.pathname === "/";
    
    // Determine Alvará text color
    // Dark mode: always white
    // Home page + not sticky + white mode: white
    // Home page + sticky + white mode: dark
    // Other pages + white mode: dark
    const alvaraColor = theme === 'dark' 
        ? '#ffffff' 
        : (isHomePage && !sticky) 
            ? '#ffffff' 
            : 'var(--color-dark)';

    const MobileMenuHandler = () => {
        document.querySelector('.mobilemenu-popup').classList.toggle("show");
        document.querySelector('body').classList.toggle("mobilemenu-show");

        var elements = document.querySelectorAll('.mobilemenu-popup .menu-item-has-children > a');
    
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.axil-submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
    }


    return (
        <>
            <header className="header axil-header header-style-1">
                <div className={`axil-mainmenu ${sticky ? "axil-sticky" : ""}`}>
                    <div className="container">
                        <div className="header-navbar" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <div className="header-logo" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0}}>
                                <Logo isSticky={sticky} />
                                <div className="d-none d-lg-block" style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: alvaraColor,
                                    whiteSpace: 'nowrap',
                                    marginTop: '10px',
                                    textAlign: 'center'
                                }}>
                                    {language === 'pt' ? 'Alvará nº 669921' : 'License nº 669921'}
                                </div>
                            </div>
                            <div className="header-main-nav" style={{flex: 1, display: 'flex', justifyContent: 'center', margin: '0 20px'}}>
                                <Nav />
                            </div>
                            <div className="header-action" style={{display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0}}>
                                <ul className="list-unstyled" style={{display: 'flex', alignItems: 'center', gap: '10px', margin: 0, padding: 0}}>
                                    <li className="header-btn d-none d-lg-block" style={{margin: 0}}>
                                        <a href="tel:+351914440333" className="axil-btn btn-fill-primary" style={{display: 'flex', alignItems: 'center', gap: '8px', margin: 0}}>
                                            {Features.BANNER.CALL_NOW_FULL[language]}
                                            <InfoButton />
                                        </a>
                                    </li>
                                    <li className="d-lg-none d-block" style={{margin: 0, marginRight: '10px'}}>
                                        <div style={{
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: alvaraColor,
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {language === 'pt' ? 'Alvará nº 669921' : 'License nº 669921'}
                                        </div>
                                    </li>
                                    <li className="mobile-menu-btn sidemenu-btn d-lg-none d-block" style={{margin: 0}}>
                                        <button className="btn-wrap" onClick={MobileMenuHandler}>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu MobileHandler={MobileMenuHandler}/>
        </>
    )
}

export default HeaderOne;